module.exports = __webpack_public_path__ + "static/media/a10.0481ed6c.jpg";